import React, { useContext, useEffect, useState } from "react";
import {
    Box,
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Grid,
    Input,
    Select,
    Text,
} from "@chakra-ui/react";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import { redirect } from "react-router-dom";
import axios from "axios";

type props = {
    bppIds: any[];
    setIsCreateModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    handleRefreshAllData: () => void;
    initialData?: any;
};

export default function CreatePayment({
    bppIds,
    setIsCreateModalOpen,
    handleRefreshAllData,
    initialData
}: props): JSX.Element {
    console.log("initial data", initialData)
    console.log("bpp ids", bppIds)
    const [formData, setFormData] = useState<any>({
        bpp_id: "",
        utr: "",
        amount: "",
    });

    const [errors, setErrors] = useState<Record<string, string>>({});
    const { toastNotify } = useContext(AppContext);

    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            setFormData({
                bpp_id: initialData.bpp_id,
                utr: initialData.utr,
                amount: initialData.amount,
            });
        }
    }, []);

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;

        setFormData((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const ValidateForm = async (): Promise<boolean> => {
        const newErrors: Record<string, string> = {};

        // Validate required fields
        if (!formData.bpp_id) newErrors.bpp_id = "Provider is required";
        if (!formData.utr) newErrors.utr = "Transaction No. is required";
        if (!formData.amount) newErrors.amount = "Amount is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!ValidateForm()) return;

        try {
            const response: any = await appRequest("metro", "addUtrWithPrice", formData);

            if (response.status === "success") {
                toastNotify({
                    title: "Success",
                    message: "Payment added successfully",
                    type: "success",
                });
                setIsCreateModalOpen(false);
                handleRefreshAllData();
            } else {
                toastNotify({
                    title: "Error in adding Payment",
                    message: response.message,
                    type: "error",
                });
            }
        } catch (error: any) {
            console.error("Error in adding Payment", error.message);
        }
    };

    return (
        <>
            <Box mt={4}>
                <form onSubmit={handleSubmit}>
                    <Grid
                        gap={6}
                        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
                        mb={8}
                        p={5}
                        shadow={"base"}
                        rounded={"lg"}
                        borderWidth={1}
                    >
                        <FormControl
                            variant={"floating"}
                            isInvalid={!!errors.bpp_id}
                        >
                            <Select
                                id="bpp_id"
                                placeholder=""
                                name="bpp_id"
                                size={{ base: "sm", md: "md" }}
                                variant="outline"
                                value={formData.bpp_id}
                                onChange={handleInputChange}
                            >
                                <option value="">Select</option>
                                {bppIds.map((bpp) => (
                                    <option key={bpp._id} value={bpp._id}>
                                        {bpp._id}
                                    </option>
                                ))}
                            </Select>
                            <FormLabel htmlFor="is_active">Provider</FormLabel>
                            <FormErrorMessage>{errors.bpp_id}</FormErrorMessage>
                        </FormControl>
                        <FormControl variant={"floating"} isInvalid={!!errors.utr}>
                            <Input
                                id="utr"
                                name="utr"
                                placeholder=""
                                value={formData.utr || ""}
                                onChange={handleInputChange}
                            />
                            <FormLabel htmlFor="redirect_url">Transaction No.</FormLabel>
                            <FormErrorMessage>{errors.utr}</FormErrorMessage>
                        </FormControl>
                        <FormControl variant={"floating"} isInvalid={!!errors.amount}>
                            <Input
                                id="amount"
                                name="amount"
                                placeholder=""
                                value={formData.amount}
                                onChange={handleInputChange}
                            />
                            <FormLabel htmlFor="name">Amount</FormLabel>
                            <FormErrorMessage>{errors.amount}</FormErrorMessage>
                        </FormControl>
                    </Grid>
                    <Flex justify={"end"} mt={4}>
                        <Button type="submit" colorScheme="teal">
                            Submit
                        </Button>
                    </Flex>
                </form>
            </Box>
        </>
    );
}
